<mat-toolbar class="text-uppercase">
  <mat-toolbar-row>
    <span>Contrapartes</span>
    <span class="spacer"></span>
    <button
      mat-raised-button
      color="primary"
      *ngIf="canCreateCounterpart()"
      data-cy="new"
      (click)="openCounterpart()"
    >
      Novo
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-accordion>
  <mat-card>
    <mat-card-header> </mat-card-header>
    <mat-card-content>
      <form #thisForm="ngForm">
        <div class="filters">
          <div class="row">
            <div class="col-4">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  placeholder="Nome"
                  [(ngModel)]="name"
                  name="name"
                />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field>
                <input
                  matInput
                  type="text"
                  placeholder="Documento"
                  [(ngModel)]="document"
                  name="document"
                />
              </mat-form-field>
            </div>
            <div class="col-2">
              <button
                mat-raised-button
                color="primary"
                class="filter-button"
                type="submit"
                (click)="clearFilters()"
              >
                Limpar
              </button>
            </div>
            <div class="col-2">
              <button
                mat-raised-button
                color="primary"
                class="filter-button"
                type="submit"
                (click)="getCounterpart()"
              >
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</mat-accordion>

<table mat-table [dataSource]="model" class="counterparts">
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let counterpart" class="actions">
      <fa-icon
        *ngIf="canCreateCounterpart()"
        id="user-{{ counterpart.id }}-id"
        [icon]="faListAlt"
        (click)="openCounterpart(counterpart.id)"
      ></fa-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Nome</th>
    <td mat-cell *matCellDef="let counterpart">{{ counterpart.name }}</td>
  </ng-container>
  <ng-container matColumnDef="document">
    <th mat-header-cell *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let counterpart">{{ counterpart.document }}</td>
  </ng-container>
  <ng-container matColumnDef="bank">
    <th mat-header-cell *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let counterpart">{{ counterpart.bank }}</td>
  </ng-container>
  <ng-container matColumnDef="account">
    <th mat-header-cell *matHeaderCellDef>Conta</th>
    <td mat-cell *matCellDef="let counterpart">{{ counterpart.account }}</td>
  </ng-container>
  <ng-container matColumnDef="branch">
    <th mat-header-cell *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let counterpart">{{ counterpart.branch }}</td>
  </ng-container>
  <ng-container matColumnDef="selicAccount">
    <th mat-header-cell *matHeaderCellDef>Conta Selic</th>
    <td mat-cell *matCellDef="let counterpart">
      {{ counterpart.selicAccount }}
    </td>
  </ng-container>
  <ng-container matColumnDef="cetipAccount">
    <th mat-header-cell *matHeaderCellDef>Conta Cetip</th>
    <td mat-cell *matCellDef="let counterpart">
      {{ counterpart.cetipAccount }}
    </td>
  </ng-container>
  <ng-container matColumnDef="brokerAccount">
    <th mat-header-cell *matHeaderCellDef>Conta de Corretagem</th>
    <td mat-cell *matCellDef="let counterpart">
      {{ counterpart.brokerAccount }}
    </td>
  </ng-container>
  <ng-container matColumnDef="b3Account">
    <th mat-header-cell *matHeaderCellDef>Conta B3</th>
    <td mat-cell *matCellDef="let counterpart">{{ counterpart.b3Account }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<paginador
  [listedPages]="listedPages"
  [firstItemOnPage]="firstItemOnPage"
  [lastItemOnPage]="lastItemOnPage"
  [totalPages]="totalPages"
  [totalItems]="totalItems"
  [itemsPerPage]="[10, 25, 50, 100]"
  [currentPage]="currentPage"
  (onSearch)="getCounterpart($event[0], $event[1])"
></paginador>
